import React, { useState } from "react";
import katex from "katex";

export function MathEditModal({ isOpen, latex, onSave, onClose }) {
    const [value, setValue] = useState(latex);
    const [preview, setPreview] = useState("");
  
    const updatePreview = (latexStr) => {
      const container = document.createElement("div");
      try {
        katex.render(latexStr, container, {
          throwOnError: false,
          displayMode: false
        });
        setPreview(container.innerHTML);
      } catch (e) {
        setPreview("Invalid LaTeX: " + e);
      }
    };
  
    React.useEffect(() => {
      setValue(latex);
      updatePreview(latex);
    }, [latex, isOpen]);
  
    const handleChange = (e) => {
      const newValue = e.target.value;
      setValue(newValue);
      updatePreview(newValue);
    };
  
    const handleSave = () => {
      onSave(value);
      onClose();
    };
  
    if (!isOpen) return null;
  
    return (
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}>
        <div style={{
          background: "white",
          borderRadius: "8px",
          padding: "24px",
          width: "500px",
          maxWidth: "90%",
          boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
        }}>
          <h3 style={{ margin: "0 0 16px 0" }}>Edit Math Expression</h3>
          
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
            LaTeX:
          </label>
          <input
            type="text"
            value={value}
            onChange={handleChange}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "14px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              fontFamily: "monospace",
              marginBottom: "8px"
            }}
            autoFocus
          />
          
          <p style={{ 
            fontSize: "12px", 
            color: "#666", 
            marginBottom: "16px",
            marginTop: "4px"
          }}>
            Need help? See{" "}
            <a 
              href="https://katex.org/docs/supported.html" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: "#16a34a", textDecoration: "none", fontWeight: "500" }}
            >
              supported KaTeX notation
            </a>
          </p>
  
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
            Preview:
          </label>
          <div
            style={{
              padding: "16px",
              background: "#f0fdf4",
              border: "1px solid #86efac",
              borderRadius: "4px",
              minHeight: "60px",
              marginBottom: "20px",
              fontSize: "18px"
            }}
            dangerouslySetInnerHTML={{ __html: preview }}
          />
  
          <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
            <button
              onClick={onClose}
              style={{
                padding: "8px 16px",
                background: "#6c757d",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              style={{
                padding: "8px 16px",
                background: "#22c55e",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer"
              }}
              onMouseOver={(e) => e.target.style.background = "#16a34a"}
              onMouseOut={(e) => e.target.style.background = "#22c55e"}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    );
  }